<script lang="ts">
  import { cn } from "$lib/utils";
  import { formatCurrency } from "$src/presentation/core/currencyUtils";
  import { ArrowDown, ArrowUp } from "lucide-svelte";

  export let value: number;
  export let currency: string;

  let className: string | undefined = undefined;

  export { className as class };
</script>

{#if value > 0}
  <div
      class={cn("flex flex-row justify-center gap-2 items-center border p-1 rounded-full border-green-500 text-green-500", className)}
  >
    <ArrowUp class={"h-3 w-3"} />
    {formatCurrency(value, currency)}
  </div>
{:else if value < 0}
  <div
  class={cn("flex flex-row justify-center gap-2 items-center border p-1 rounded-full border-red-500 text-red-500", className)}
  >
    <ArrowDown class={"h-3 w-3"} />
    {formatCurrency(value, currency)}
  </div>
{:else}
  <div
  class={cn("flex flex-row justify-center gap-2 items-center border p-1 rounded-full border-yellow-500 text-yellow-500", className)}
  >
    {formatCurrency(value, currency)}
  </div>
{/if}
